import PayCheckScreen from 'features/believe/makePayment/PayCheckScreen/PayCheckScreen';
import React from 'react';

export default function Page() {
  return <PayCheckScreen />;
}
